import { render, staticRenderFns } from "./WsAccredCompsDocuments.vue?vue&type=template&id=461e2099"
import script from "./WsAccredCompsDocuments.vue?vue&type=script&lang=js"
export * from "./WsAccredCompsDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports